import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import Helmet from "react-helmet";
import ZendeskNewRequestLink from "../common/links/zendesk-new-request-link";
import RelatedCases from "./related-cases";
import { getRelatedCases } from "../../services/api-company";
import { Divider, Statistic, Card, Row, Col, Checkbox } from "antd";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  reportErrorLink: {
    float: "right",
    fontWeight: 400,
    fontSize: "0.7em"
  }
};

class CompanyCases extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired
  };

  state = {
    loading: true,
    list: {
      ptab: {
        petitioners: [],
        patent_owners: []
      },
      litigation: {
        plaintiff: [],
        defendant: []
      },
      exparte: {
        requester: [],
        owner: []
      },
      patent: {
        assignee_current: []
      }
    },
    count: {
      ptab: {
        petitioners: 0,
        patent_owners: 0
      },
      litigation: {
        plaintiff: 0,
        defendant: 0
      },
      exparte: {
        requester: 0,
        owner: 0
      },
      patent: {
        assignee_current: 0
      }
    },
    parent: null,
    subsidiaries: null,
    shouldQuerySubsidiaries: true
  };

  componentDidMount() {
    this._isMounted = true;
    this._getCases(this.props.name);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { list, count, parent, subsidiaries, loading, shouldQuerySubsidiaries } = this.state;
    const { name } = this.props;
    return (
      <>
        <div style={{ display: "flex", alignItems: "center", paddingTop: 8, paddingBottom: 16 }}>
          {subsidiaries
            ? (
              <Checkbox checked={shouldQuerySubsidiaries} onChange={this._handleSubsidiariesCheckbox}>
                Include {subsidiaries.length} Subsidiaries
              </Checkbox>
            )
            : null}
          {parent && subsidiaries ? <Divider type="vertical" /> : null}
          {parent
            ? (
              <div>
                Ultimate Parent: <Link to={`/company/${parent}`}>{parent}</Link>
              </div>
            )
            : null}
        </div>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <a href="#ptab">
              <Card hoverable={true}>
                <Statistic title="PTAB Cases" value={count.ptab.petitioners + count.ptab.patent_owners} loading={loading} />
              </Card>
            </a>
          </Col>
          <Col span={6}>
            <a href="#exparte">
              <Card hoverable={true}>
                <Statistic title="Ex-Parte Reexams" value={count.exparte.requester + count.exparte.owner} loading={loading} />
              </Card>
            </a>
          </Col>
          <Col span={6}>
            <a href="#litigation">
              <Card hoverable={true}>
                <Statistic title="Litigation Cases" value={count.litigation.plaintiff + count.litigation.defendant} loading={loading} />
              </Card>
            </a>
          </Col>
          <Col span={6}>
            <a href="#patent">
              <Card hoverable={true}>
                <Statistic title="Patents" value={count.patent.assignee_current} loading={loading} />
              </Card>
            </a>
          </Col>
        </Row>
        <Divider />
        <h3 id="ptab">PTAB</h3>
        <RelatedCases source="ptab" cases={list.ptab} counts={count.ptab} name={name} loading={loading} />
        <Divider />
        <h3 id="exparte">Ex-Parte Reexams</h3>
        <RelatedCases source="exparte" cases={list.exparte} counts={count.exparte} name={name} loading={loading} />
        <Divider />
        <h3 id="litigation">Litigation</h3>
        <RelatedCases source="litigation" cases={list.litigation} counts={count.litigation} name={name} loading={loading} />
        <Divider />
        <h3 id="patent">Patents</h3>
        <RelatedCases source="patent" cases={list.patent} counts={count.patent} name={name} loading={loading} />
      </>
    );
  }

  _getCases = name => {
    this.setState({ loading: true });
    return getRelatedCases(name, this.state.shouldQuerySubsidiaries)
      .then(({ list, count, ultimate_parent: parent, subsidiaries }) => {
        if (this._isMounted) {
          this.setState({
            list,
            count,
            parent,
            subsidiaries,
            loading: false
          });
        }
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({
            loading: false
          });
        }
      });
  }

  _handleSubsidiariesCheckbox = e => {
    if (this._isMounted) {
      this.setState(
        { shouldQuerySubsidiaries: e.target.checked },
        () => this._getCases(this.props.name)
      );
    }
  };
}

const Company = props => {
  const { name } = props.params;
  const helmet = {
    title: name,
    meta: [
      { name: "keywords", content: "PTAB petitioner, PTAB patent owner, Re-exam requester, Re-exam patent owner, district court plaintiff, district court defendant" },
      { name: "description", content: `Summary of patent litigation and invalidation for ${name}` }
    ]
  };
  return (
    <div style={styles.body}>
      <Helmet {...helmet} />
      <h2 style={{ margin: 0 }}>
        {name}
        <ZendeskNewRequestLink text="Report Error" subjectPrefix="Correction needed for page" style={styles.reportErrorLink} className="hidden-sm" />
      </h2>
      <CompanyCases name={name} key={name} />
    </div>
  );
};

export default Company;
